import {
  getJobSearchGuidePublicSeo,
  type JobSearchGuideLocale,
} from './job-search-guides-public-seo';

export type IndexationDiscoveryLink = {
  href: string;
  label: string;
};

/** Strip `/en|fi|sv` prefix for Footer `Link` paths (locale added by component). */
export function toLocaleRelativeAppPath(fullPath: string): string {
  const stripped = fullPath.replace(/^\/(en|fi|sv)(?=\/)/, '');
  return stripped.length > 0 ? stripped : fullPath;
}

export function buildJobSearchGuideFooterLinks(
  locale: JobSearchGuideLocale,
): IndexationDiscoveryLink[] {
  const pillar = getJobSearchGuidePublicSeo('finlandPillar', locale);
  const tracker = getJobSearchGuidePublicSeo('applicationTracker', locale);

  if (locale === 'fi') {
    return [
      {
        href: toLocaleRelativeAppPath(pillar.path),
        label: 'Miten löydät töitä Suomessa',
      },
      {
        href: toLocaleRelativeAppPath(tracker.path),
        label: 'Työhakemusten seuranta',
      },
    ];
  }

  if (locale === 'sv') {
    return [
      {
        href: toLocaleRelativeAppPath(pillar.path),
        label: 'Hur hittar man jobb i Finland',
      },
      {
        href: toLocaleRelativeAppPath(tracker.path),
        label: 'Jobbansökningsspårare',
      },
    ];
  }

  return [
    {
      href: toLocaleRelativeAppPath(pillar.path),
      label: 'How to find a job in Finland',
    },
    {
      href: toLocaleRelativeAppPath(tracker.path),
      label: 'Job application tracker',
    },
  ];
}

export function buildJuniorsFooterLink(locale: JobSearchGuideLocale): IndexationDiscoveryLink {
  if (locale === 'fi') {
    return { href: '/juniors', label: 'Uravinkit juniorille' };
  }
  if (locale === 'sv') {
    return { href: '/juniors', label: 'Karriär för juniorer' };
  }
  return { href: '/juniors', label: 'Careers for juniors' };
}

export function buildEmployerScoreFooterLink(locale: JobSearchGuideLocale): IndexationDiscoveryLink {
  if (locale === 'fi') {
    return { href: '/about-employer-score', label: 'Työnantajapiste-algoritmi' };
  }
  if (locale === 'sv') {
    return { href: '/about-employer-score', label: 'Arbetsgivarpoäng-algoritmen' };
  }
  return { href: '/about-employer-score', label: 'Employer Score methodology' };
}

export function getJobSearchGuideAbsolutePaths(locale: JobSearchGuideLocale): {
  pillar: string;
  tracker: string;
} {
  return {
    pillar: getJobSearchGuidePublicSeo('finlandPillar', locale).path,
    tracker: getJobSearchGuidePublicSeo('applicationTracker', locale).path,
  };
}

export function getJuniorsHubAbsolutePath(locale: JobSearchGuideLocale): string {
  return `/${locale}/juniors`;
}

export function getEmployerScoreAbsolutePath(locale: JobSearchGuideLocale): string {
  return `/${locale}/about-employer-score`;
}
